(() => {
    // js/custom-element/custom-html-element.js
  var CustomHTMLElement = class extends HTMLElement {
    constructor() {
      super();
      this._hasSectionReloaded = false;
      if (Shopify.designMode) {
        this.rootDelegate.on("shopify:section:select", (event) => {
          const parentSection = this.closest(".shopify-section");
          if (event.target === parentSection && event.detail.load) {
            this._hasSectionReloaded = true;
          }
        });
      }
    }
    get rootDelegate() {
      return this._rootDelegate = this._rootDelegate || new main_default(document.documentElement);
    }
    get delegate() {
      return this._delegate = this._delegate || new main_default(this);
    }
    showLoadingBar() {
      triggerEvent(document.documentElement, "theme:loading:start");
    }
    hideLoadingBar() {
      triggerEvent(document.documentElement, "theme:loading:end");
    }
    untilVisible(intersectionObserverOptions = { rootMargin: "30px 0px", threshold: 0 }) {
      const onBecameVisible = () => {
        this.classList.add("became-visible");
        this.style.opacity = "1";
      };
      return new Promise((resolve) => {
        if (window.IntersectionObserver) {
          this.intersectionObserver = new IntersectionObserver((event) => {
            if (event[0].isIntersecting) {
              this.intersectionObserver.disconnect();
              requestAnimationFrame(() => {
                resolve();
                onBecameVisible();
              });
            }
          }, intersectionObserverOptions);
          this.intersectionObserver.observe(this);
        } else {
          resolve();
          onBecameVisible();
        }
      });
    }
    disconnectedCallback() {
      var _a;
      this.delegate.destroy();
      this.rootDelegate.destroy();
      (_a = this.intersectionObserver) == null ? void 0 : _a.disconnect();
      delete this._delegate;
      delete this._rootDelegate;
    }
  };

  //js/custom-element/section/product/glory-variants.js
  var RayVariants = class extends CustomHTMLElement {
    constructor() {
      super();
      this.state = {
        selectedVariant: null,
        product: null,
        variants: [],
        adjustableProduct: null,
        adjustableVariants: [],
        mountIndex: 0,
        mountType: '',
        panelWatt: '200W',        // '200W' | '285W'
        panelCount: 1,            // number of boards (4x default)
        cableLength: '5m',
        adjustable: 'before',
        hideSoldOut: this.hasAttribute('hide-sold-out-variants'),
        prodIndex: null,           // 1-based prod_index from data-prod-index
        bracketVariantId: null,
        addons: [],
        taxConfirmed: false,
        pendingBuyNow: false
      };
    }

    connectedCallback() {

      this._sectionRoot = this.closest('[id^="shopify-section-"]') || document;

      this.handle = this.getAttribute('handle');
      this.adjustHandle = this.getAttribute('adjustable-handle') || null;
      this.formId = this.getAttribute('form-id');
      this.code = this.dataset.code || null;
      this.addonsSource = this.getAttribute('addons-source') || null;


      this._wireCartButtons();


      // DOM refs
      this.$mountFieldset = this.querySelector('fieldset.oip');
      this.$mountRadios = [...this.$mountFieldset.querySelectorAll('.oip__radio, input[name="mounting_type"]')];

      const adj = this.querySelector('input[name="adjustable"][value="before"]');
      if (adj) adj.checked = true;
      this.state.adjustable = 'before';

      this.$cableWrap = this.querySelector('[data-selector-type="cable-length"]');
      this.$cableRadios = this.$cableWrap ? [...this.$cableWrap.querySelectorAll('.variant-swatch__radio')] : [];

      this.$panelWrap = this.querySelector('[data-selector-type="solar-panel"]');
      this.$panelWattSpan = this.querySelector('#panel-watt span');
      this.$w200 = this.$panelWrap?.querySelector('[data-set="w200"]') || null;
      this.$w285 = this.$panelWrap?.querySelector('[data-set="w285"]') || null;
      this.$w200Radios = this.$w200 ? [...this.$w200.querySelectorAll('.variant-swatch__radio')] : [];
      this.$w285Radios = this.$w285 ? [...this.$w285.querySelectorAll('.variant-swatch__radio')] : [];


      // Event bindings
      this._bindMount();
      this._bindCable();
      this._bindPanels();
      this._bindAdjustable();
      
      this._bindProductCardCheckbox();
      this._onTaxConfirm = () => this._confirmTax();
      document.documentElement.addEventListener('ray:tax-confirm', this._onTaxConfirm);

      // Load product & initialize
      this._loadProductJSON().then(async() => {
        if (this.adjustHandle) {
          await this._loadAdjustableProductJSON();
        }
        this._setDefaults();
        this._applyMountRules();       // enable/disable groups by mount
        this._toggleAdjustableVisibility();
        this._refreshAvailability();   // disable radios that can't resolve to available variants
        this._updateVariantSelection();// pick & push correct variant into <select name="id">
        this._emitState();             // let theme know
      }).catch(() => {
        // still attempt defaults if JSON fails, but variant selection won’t resolve
        this._setDefaults();
        this._applyMountRules();
        this._toggleAdjustableVisibility();
        this._emitState();
      });
    }

    disconnectedCallback() {
      this._sectionRoot?.removeEventListener('ray:tax-confirm', this._onTaxConfirm);
      this._modeAttrMO?.disconnect();
    }



    _getSelectedBundle() {
      const root = this.$bundlePanel || document.querySelector('#tab1 .bundle-wrapper');
      if (!root) return null;

      // your card markup uses `.box` as the card; we also support `.bundle-card`
      const card = root.querySelector('.bundle-radio:checked')?.closest('.bundle-card, .box');
      if (!card) return null;

      // data-* are attached to the card element (see previous step where we added them)
      let sod = [];
      try { sod = JSON.parse(card.getAttribute('data-sod') || '[]'); } catch {}

      return {
        variantId: card.getAttribute('data-variant-id'),
        price:     Number(card.getAttribute('data-price'))   || 0,
        compare:   Number(card.getAttribute('data-compare')) || Number(card.getAttribute('data-price')) || 0,
        title:     card.getAttribute('data-title') || 'Bundle',
        handle:    card.getAttribute('data-handle') || '',
        sodItems:  Array.isArray(sod) ? sod : []
      };
    }

    /* ---------------------------
      Data loading & parsing
    ----------------------------*/
    async _loadProductJSON() {
      if (!this.handle) return; // API call glory prod
      const url = `${window.Shopify && Shopify.routes ? Shopify.routes.root : '/'}products/${this.handle}.js`;
      const res = await fetch(url, { credentials: 'same-origin' });
      if (!res.ok) throw new Error('Product JSON fetch failed');
      const data = await res.json();
      this.state.product = data;
      this.state.variants = data.variants || [];
    }

    async _loadAdjustableProductJSON() {
      const url = `${Shopify.routes.root}products/${this.adjustHandle}.js`;
      const res = await fetch(url, { credentials: 'same-origin' });
      if (!res.ok) throw new Error('Adjustable product load failed');
      const data = await res.json();
      this.state.adjustableProduct = data;
      this.state.adjustableVariants = data.variants || [];
    }

    _bindProductCardCheckbox() {
      // Find the element: prefer explicit selector, else nearest in the same section, else first on page
      const src = this.addonsSource
        ? document.querySelector(this.addonsSource)
        : this.closest('[id^="shopify-section"]')?.querySelector('product-card-checkbox')
          || document.querySelector('product-card-checkbox');

      if (!src) return;
      this.$productCardCheckbox = src;

      this._onPCCChange = (e) => {
        const items = e.detail?.items || [];
        this.state.addons = items.map(a => ({
          key: String(a.variantId),
          variantId: a.variantId,
          title: a.title,
          img_src: a.img_src,
          qty: Math.max(1, Number(a.qty) || 1),
          each: this._num(a.price),
          compare: this._num(a.compare || a.price),
          checked: true 
        }));
        // refresh SOD + totals + event payload
        this._emitState();
      };

      this.$productCardCheckbox.addEventListener('productcardcheckbox:change', this._onPCCChange);

      // Initial hydrate
      if (typeof this.$productCardCheckbox.getSnapshot === 'function') {
        const snap = this.$productCardCheckbox.getSnapshot();
        this._onPCCChange({ detail: snap });
      }
    }

    _parseVariant(variant) {
      const opts = Array.isArray(variant.options) ? variant.options : [];
      const opt1 = (opts[0] || '').trim(); // mount type (Shield/Garden/Glass/etc.)
      const opt2 = (opts[1] || '').trim(); // e.g. "2 Panels (570W)"
      const opt3 = (opts[2] || '').trim();

      // --- Panel count
      let count = null;
      {
        const m = opt2.match(/(\d+)\s*panel/i);
        if (m) count = parseInt(m[1], 10);
      }

      // --- Total watt inside parentheses (e.g. "(570W)")
      let perPanelWatt = null;
      {
        const total = opt2.match(/\((\d+)\s*w\)/i);
        if (total && count) {
          const totalW = parseInt(total[1], 10);
          const per = Math.round(totalW / count); // safe integer division

          // Normalize: must be one of our valid SKUs
          if (per === 200) perPanelWatt = '200W';
          else if (per === 285) perPanelWatt = '285W';
        }
      }

      // --- Cable length
      let cableLength = null;
      {
        const m = opt3.match(/(\d+)\s*m/i);
        if (m) cableLength = `${parseInt(m[1], 10)}m`;
      }

      return {
        id: variant.id,
        available: !!variant.available,
        mountType: opt1 || null,
        count,
        watt: perPanelWatt,
        cableLength
      };
    }

    /* ---------------------------
      Defaults & bindings
    ----------------------------*/
    _setDefaults() {
      const firstMountRadio = this.$mountRadios.find(r => r.classList.contains('oip__radio')) || this.$mountRadios[0];
      if (firstMountRadio) {
        firstMountRadio.checked = true;
        this.state.mountIndex = this._mountIndexFromId(firstMountRadio.id);
        this.state.mountType = firstMountRadio.dataset.rayVar;
      }

      // NEW: read meta from the currently checked card
      const card = this._getCheckedMountCard();
      const { prodIndex, bracketVariantId, bracketPrice, bracketCompare } = this._readMountMeta(card);
      this.state.prodIndex = prodIndex;
      this.state.bracketVariantId = bracketVariantId;
      this.state.bracketPrice = bracketPrice;
      this.state.bracketCompare = bracketCompare

      // Panels default (unchanged)
      const r200x1 = this.$panelWrap?.querySelector('input[name="option_panel"][data-bind-value="200W"][value="1"]');
      const any200 = this.$panelWrap?.querySelector('input[name="option_panel"][data-bind-value="200W"]');
      if (r200x1) {
        r200x1.checked = true;
        this.state.panelWatt = '200W';
        this.state.panelCount = 1;
      } else if (any200) {
        any200.checked = true;
        this.state.panelWatt = '200W';
        this.state.panelCount = Number(any200.value) || 0;
      }
      // reflect UI
      this._updatePanelWatt();

      if (this.$cableRadios?.length) {
        const c5 = this.$cableRadios.find(r => String(r.value).toLowerCase() === '5m') || this.$cableRadios[0];

        if (c5) {
          c5.checked = true;
          this.state.cableLength = c5.value;
        }
      }

      this._updateBatteryWatt(); // reflect default in UI
    }

    _bindMount() {
      if (!this.$mountFieldset) return;
      this.$mountFieldset.addEventListener('change', (e) => {
        const inp = e.target;
        if (!inp || inp.name !== 'mounting_type') return;

        this.state.mountIndex = this._mountIndexFromId(inp.id);
        this.state.mountType = inp.dataset.rayVar;

        const mt = (this.state.mountType || '').toLowerCase();
        const enableAfter = (mt === 'glass' || mt === 'shield' || mt === 'railing');

        if (!enableAfter){
          this.state.adjustable = 'before';
          const beforeRadio = this.querySelector(
            'input[name="adjustable"][value="before"], input[name="adjust_bracket"][value="before"]'
          );
          if (beforeRadio) beforeRadio.checked = true;
        }

        const card = this._getCheckedMountCard();
        const { prodIndex, bracketVariantId, bracketPrice, bracketCompare } = this._readMountMeta(card);
        this.state.prodIndex = prodIndex;
        this.state.bracketVariantId = bracketVariantId;
        this.state.bracketPrice = bracketPrice;
        this.state.bracketCompare = bracketCompare;
        
        this._toggleAdjustableVisibility();
        this._applyMountRules();      // now uses prodIndex
        this._refreshAvailability();
        this._updateVariantSelection();
        this._emitState();
      });
    }

    _bindAdjustable() {
      const wrap = this.querySelector('.adjustable-fieldset');
      if (!wrap) return;

      wrap.addEventListener('change', (e) => {
        const inp = e.target;
        if (!inp || inp.name !== 'adjust_bracket') return;
        this.state.adjustable = inp.value; // "before" | "after"
        this._updateVariantSelection();
        this._emitState();
      });
    }


    _bindCable() {
      if (!this.$cableWrap) return;
      this.$cableWrap.addEventListener("change", (e) => {
        const inp = e.target;
        if (!inp || inp.name !== "cable") return;

        this.state.cableLength = inp.value; // "5m" | "10m"
        this._updateVariantSelection();
        this._emitState();
      });
    }


    _bindPanels() {
      if (!this.$panelWrap) return;
      this.$panelWrap.addEventListener('change', (e) => {
        const inp = e.target;
        if (!inp || inp.name !== 'option_panel' || !inp.classList.contains('variant-swatch__radio')) return;

        // watt bucket from data-bind-value; quantity from value
        const bind = (inp.dataset.bindValue || inp.getAttribute('data-bind-value') || '').toUpperCase();
        const wattStr = /285/.test(bind) ? '285W' : '200W';
        const count = Number(inp.value);

        this.state.panelWatt = wattStr;
        this.state.panelCount = Number.isFinite(count) ? count : 0;

        // Push to form + UI + listeners
        this._updateVariantSelection();
        this._updatePanelWatt();
        this._emitState();
      });
    }

    // --- helper: get the checked mount card (label.oip__card)
    _num(v) { const n = Number(v); return Number.isFinite(n) ? n : 0; }
    _money(cents) {
      const n = Number(cents) || 0;

      try {
        const fmt = window.themeVariables?.settings?.currencyCodeEnabled
          ? window.themeVariables?.settings?.moneyWithCurrencyFormat
          : window.themeVariables?.settings?.moneyFormat;

        if (typeof window.formatMoney === 'function' && fmt) {
          return window.formatMoney(n, fmt);
        }
      } catch (_e) {}

      const v = n / 100;

      return new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR'
      }).format(v);
    }
    _sel(el, s) { return el?.querySelector(s) || null; }
    _setText(el, txt) { if (el) el.textContent = String(txt); }
    _show(el, on=true) { if (el) el.style.display = on ? '' : 'none'; }

    _getCheckedMountCard() {
      const checked = this.$mountRadios.find(r => r.checked && r.id !== 'without');
      return checked ? checked.closest('.oip__item')?.querySelector('.variant-one__item') : null;
    }

    _toggleAdjustableVisibility() {
      const fieldset = this.querySelector('.adjustable-fieldset');
      const grid = this.querySelector('.variant-swatch-grid'); // your grid wrapper
      const mt = (this.state.mountType || '').toLowerCase();

      if (!fieldset) return;

      const show = (mt === 'glass' || mt === 'shield' || mt === 'railing');

      // Hide: restore it back to normal flow (optional) and hide
      if (!show) {
        fieldset.style.display = 'none';

        // optional cleanup: if it was previously wrapped in a row, unwrap it
        const row = this.querySelector('.mount-extra-row');
        if (row && row.contains(fieldset)) {
          row.insertAdjacentElement('afterend', fieldset);
          row.remove();
        }
        return;
      }

      // Show
      fieldset.style.display = 'flex'; // keep your original display behavior

      if (!grid) return;

      // Ensure a full-width row exists inside the grid
      let row = grid.querySelector('.mount-extra-row');
      if (!row) {
        row = document.createElement('div');
        row.className = 'mount-extra-row';
      }

      // Make sure row spans full grid width (in case CSS missing)
      row.style.gridColumn = '1 / -1';

      // Put fieldset inside that row (so it's a single full-width grid child)
      if (fieldset.parentElement !== row) {
        row.appendChild(fieldset);
      }

      // Find the selected mount item index
      const items = Array.from(grid.querySelectorAll('.oip__item'));
      const selectedIdx = Math.max(
        0,
        items.findIndex(item => {
          const r = item.querySelector('input[name="mounting_type"]');
          return r && r.checked;
        })
      );

      // 3 columns per your CSS: repeat(3, 1fr)
      const COLS = 3;
      const rowEndIdx = Math.min(items.length - 1, Math.ceil((selectedIdx + 1) / COLS) * COLS - 1);

      // Insert the row right after the last item of the selected row
      const anchor = items[rowEndIdx];
      if (anchor) {
        anchor.insertAdjacentElement('afterend', row);
      } else {
        grid.appendChild(row);
      }
    }


    _updateBatteryWatt() {
      const qty = Number(this.state.storageCount) || 0;
      const total = this.baseBatteryWatt * (1 + qty);
      if (this.$batteryWattSpan) {
        this.$batteryWattSpan.textContent = `${total}Wh`;
      }
    }

    _getPerPanelWatt(wattStr) {
      const m = String(wattStr || '').match(/\d+/);
      return m ? Number(m[0]) : 0; // '200W' -> 200
    }

    _updatePanelWatt() {
      if (!this.$panelWattSpan) return;
      const per = this._getPerPanelWatt(this.state.panelWatt); // '200W'|'285W'
      const total = per * (Number(this.state.panelCount) || 0);
      this.$panelWattSpan.textContent = `${total}W`;
    }

    _readMountMeta(card) {
      if (!card) return { prodIndex: null, bracketVariantId: null, mountName: '' };
      const prodIndex = Number(card.dataset.prodIndex || card.getAttribute('data-prod-index')) || null;
      const bracketVariantId = card.dataset.variantId || card.getAttribute('data-variant-id') || null;
      const bracketPrice = card.dataset.variantPrice || card.getAttribute('data-variant-price') || null;
      const bracketCompare = card.dataset.variantCompare || card.getAttribute('data-variant-compare') || null;
      const mountName = card.querySelector('.oip__title')?.textContent?.trim() || '';
      return { prodIndex, bracketVariantId, mountName, bracketPrice, bracketCompare };
    }

    _mountIndexFromId(id) {
      // your radio id format: {{ product.id }}-mount-{{ forloop.index }}
      const m = id.match(/mount-(\d+)/);
      return m ? (parseInt(m[1], 10) - 1) : 0;
    }

    /* ---------------------------
      Mount rules & availability
    ----------------------------*/
    _applyMountRules() {
      const pidx = this.state.prodIndex;
      let enable200 = false;
      let enable285 = false;

      if (pidx === 1 || pidx === 2) {
        enable200 = true;
      } else if (pidx === 3) {
        enable285 = true;
      } else if (pidx === null || pidx === -1) {
        enable200 = true;
        enable285 = true;
      }

      this._setGroupEnabled(this.$w200, this.$w200Radios, enable200);
      this._setGroupEnabled(this.$w285, this.$w285Radios, enable285);

      // If current selection is invalid (disabled group), auto-fallback
      if (!enable200 && this.state.panelWatt === '200W') {
        const first = this.$w285Radios.find(r => !r.disabled) || this.$w285Radios[0];
        if (first) {
          first.checked = true;
          this.state.panelWatt = '285W';
          this.state.panelCount = Number(first.value) || 0;
          this._updatePanelWatt();
        }
      } else if (!enable285 && this.state.panelWatt === '285W') {
        const first = this.$w200Radios.find(r => !r.disabled) || this.$w200Radios[0];
        if (first) {
          first.checked = true;
          this.state.panelWatt = '200W';
          this.state.panelCount = Number(first.value) || 0;
          this._updatePanelWatt();
        }
      }
    }

    _setGroupEnabled(groupEl, radios, enabled) {
      if (!groupEl) return;
      groupEl.style.pointerEvents = enabled ? '' : 'none';
      groupEl.style.opacity = enabled ? '' : '0.4';
      radios.forEach(r => {
        r.disabled = !enabled;
        const wrap = r.closest('.card__quantity-button-wrapper');
        if (wrap) wrap.classList.toggle('is-disabled', !enabled);
      });
    }

    // _wireCartButtons() {
    //   const form = this.formId ? document.getElementById(this.formId) : null;
    //   if (!form) return;
      

    //   form.addEventListener('submit', (e) => {
    //     e.preventDefault();
    //     this._addBundleToCart({ buyNow: false });
    //   });

    //   const atcBtn = form.querySelector('[data-bundle-atc]');
    //   if (atcBtn) atcBtn.addEventListener('click', (e) => {
    //     e.preventDefault();
    //     this._addBundleToCart({ buyNow: false });
    //   });

    //   const buyNowBtn = form.querySelector('[data-bundle-buynow]');
    //   if (buyNowBtn) buyNowBtn.addEventListener('click', (e) => {
    //     e.preventDefault();
    //     this._addBundleToCart({ buyNow: true });
    //   });
    // }

    _wireCartButtons() {
      const form = this.formId ? document.getElementById(this.formId) : null;
      if (!form) return;

      const requiresTaxPopup = !!this._sectionRoot.querySelector('.tax-info');

      // internal one-shot flag
      this.state.taxConfirmed = false;
      this.state.pendingBuyNow = false;

      // show popup
      const showPopup = () => {
        document.documentElement.dispatchEvent(new CustomEvent('ray:tax-popup', {
          bubbles: true
        }));
      };

      // confirmation event from popup
      this._onTaxConfirm = () => {
        this.state.taxConfirmed = true;
        this._addBundleToCart({ buyNow: this.state.pendingBuyNow });

        // reset state after add to cart
        this.state.taxConfirmed = false;
        this.state.pendingBuyNow = false;

        // reset popup UI
        const backdrop = document.querySelector('.tax-info-popup-backdrop');
        const checkbox = backdrop?.querySelector('#vat-inclusion');
        const continueBtn = backdrop?.querySelector('.button.button--primary');

        if (checkbox) checkbox.checked = false;
        if (continueBtn) continueBtn.disabled = true;
      };

      document.documentElement.addEventListener('ray:tax-confirm', this._onTaxConfirm);

      // ---- helper to intercept clicks
      const intercept = (e, buyNow) => {
        e.preventDefault();

        if (requiresTaxPopup && !this.state.taxConfirmed) {
          this.state.pendingBuyNow = buyNow;
          showPopup();
          return;
        }

        // no popup, or confirmed
        this._addBundleToCart({ buyNow });

        // reset after success (normal path)
        this.state.taxConfirmed = false;
      };

      const atcBtn = form.querySelector('[data-bundle-atc]');
      const buyBtn = form.querySelector('[data-bundle-buynow]');

      if (atcBtn) atcBtn.addEventListener('click', (e) => intercept(e, false));
      if (buyBtn) buyBtn.addEventListener('click', (e) => intercept(e, true));

      // (optional) block enter key submit
      form.addEventListener('submit', (e) => intercept(e, false));
    }


    _composeBundleItems() {
      let items = [];
      // Main variant (selected variant must exist)
      const main = this.state.selectedVariant;
      if (!main) return [];

      const panelQty = Number(this.state.panelCount) || 0;
      const storageQty = Number(this.state.storageCount) || 0;
      const hasBracket = !!this.state.bracketVariantId;
      const bracketQty = hasBracket ? panelQty : 0;



      items = [{
        id: Number(main.id),
        quantity: 1,
      }];

      // Changed Brackets to Ray Product variant
      if (hasBracket && bracketQty > 0) {
        const rayProduct = this.state.selectedRayVariant;
        items.push({
          id: Number(rayProduct.id),
          quantity: this.state.selectedRayQty
        });
      }

      // Expansion batteries
      if (this.state.storageVariantId && storageQty > 0) {
        items.push({
          id: Number(this.state.storageVariantId),
          quantity: storageQty
        });
      }

      this.state.addons
        .filter(a => a.checked && a.variantId && a.qty > 0)
        .forEach(a => {
          items.push({
            id: Number(a.variantId),
            quantity: a.qty
          });
        });

      return items;
    }

    async _addBundleToCart({ buyNow = false } = {}) {
      const items = this._composeBundleItems();
      if (!items.length) {
        console.warn('[ray-variants] No items to add (no selectedVariant?)');
        return;
      }
      // Optional: lock buttons
      this._setBusy(true);

      try {
        const addRes = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items })
        });

        const addJson = await addRes.json();
        if (!addRes.ok) {
          document.documentElement.dispatchEvent(new CustomEvent('cart-notification:show', {
            bubbles: true,
            cancelable: true,
            detail: { status: 'error', error: addJson?.description || 'An error occurred' }
          }));
          throw new Error(addJson?.description || `Cart add failed (${addRes.status})`);
        }

        const popup = document.querySelector(".product-popup");
        const popupClose = document.querySelector(".popup-close");

        if (popup && popup.classList.contains("active")) {
          popupClose.click();
        }

         // Fire "variant:added" with first item (same as your example)
        document.documentElement.dispatchEvent(new CustomEvent('variant:added', {
          bubbles: true,
          detail: {
            variant: addJson.hasOwnProperty('items') ? addJson.items[0] : addJson
          }
        }));
        const cartUrl = (window.themeVariables?.routes?.cartUrl || '/cart') + '.js';
        const cartRes = await fetch(cartUrl, { headers: { 'Accept': 'application/json' } });
        if (cartRes.ok) {
        const cartContent = await cartRes.json();

        // Fire cart:updated
        document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
          bubbles: true,
          detail: { cart: cartContent }
        }));

        // Attach any sections returned by /cart/add.js (if theme uses them)
        if (addJson.sections) cartContent.sections = addJson.sections;

        // Fire cart:refresh (theme listens to this to render UI)
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: {
            cart: cartContent,
            openMiniCart:
              window.themeVariables?.settings?.cartType === 'drawer' &&
              document.querySelector('.drawer') === null
          }
        }));
        }

        if (buyNow) {
          // After adding bundle, go straight to checkout
          window.location.href = '/checkout';
          return;
        }

        // Open mini-cart by clicking the header trigger (same as your example)
        const headerCart = document.querySelector('.header_show-cart');
        if (headerCart) headerCart.click();
       
      } catch (e) {
        console.error('[glory-variants] Add bundle failed:', e);
        // Optional: show toast/snackbar
        alert(e.message || 'Something went wrong adding to cart.');
      } finally {
        this._setBusy(false);
      }
    }

    async _openCartDrawer(addResponse = null) {
      // 1) Dawn-style <cart-drawer> component
      const drawerEl = document.querySelector('cart-drawer');
      if (drawerEl) {
        try {
          // If /cart/add.js returned sections, let Dawn render them
          if (addResponse?.sections && typeof drawerEl.renderContents === 'function') {
            drawerEl.renderContents(addResponse);
          } else if (typeof drawerEl.renderContents === 'function') {
            // Otherwise fetch the drawer sections and render
            const res = await fetch(`${Shopify.routes.root}?sections=cart-drawer,cart-icon-bubble`);
            const json = await res.json();
            drawerEl.renderContents({ sections: json, sections_url: window.location.pathname });
          }
        } catch (e) {
          // swallow and try to just open visually
        }
        // Open it (Dawn accepts either .open() or adding classes/attrs)
        if (typeof drawerEl.open === 'function') drawerEl.open();
        drawerEl.classList.add('is-open');
        drawerEl.setAttribute('open', '');
        document.documentElement.classList.add('overflow-hidden');
        document.body.classList.add('overflow-hidden');
        return;
      }

      // 2) “CartDrawer” container patterns
      const idDrawer = document.getElementById('CartDrawer');
      if (idDrawer) {
        try {
          if (addResponse?.sections?.['cart-drawer']) {
            const doc = new DOMParser().parseFromString(addResponse.sections['cart-drawer'], 'text/html');
            const src = doc.getElementById('CartDrawer');
            if (src) idDrawer.innerHTML = src.innerHTML;
          } else {
            const res = await fetch(`${Shopify.routes.root}?sections=cart-drawer,cart-icon-bubble`);
            const json = await res.json();
            if (json['cart-drawer']) {
              const doc = new DOMParser().parseFromString(json['cart-drawer'], 'text/html');
              const src = doc.getElementById('CartDrawer');
              if (src) idDrawer.innerHTML = src.innerHTML;
            }
          }
        } catch (e) {}
        idDrawer.classList.add('is-open', 'active', 'open');
        document.documentElement.classList.add('overflow-hidden');
        document.body.classList.add('overflow-hidden');
        return;
      }

      // 3) Fire common events many themes listen for
      ['cart:open', 'cart:refresh', 'cart:updated', 'ajaxProduct:added', 'theme:cart:added'].forEach(name => {
        document.dispatchEvent(new CustomEvent(name, { bubbles: true }));
      });

      // 4) Try clicking a toggle button
      const toggle = document.querySelector(
        '[data-cart-toggle], [aria-controls="CartDrawer"], .header__icon--cart button, .header__icon--cart a'
      );
      if (toggle) { toggle.click(); return; }

      // 5) Last resort: go to the cart page
      window.location.href = '/cart';
    }

    _setBusy(on) {
      const form = this.formId ? document.getElementById(this.formId) : null;
      if (!form) return;
      form.classList.toggle('is-loading', !!on);
      const btns = form.querySelectorAll('[data-bundle-atc], [data-bundle-buynow], .product-form__submit');
      btns.forEach(b => b.disabled = !!on);
    }

    // Patch _refreshAvailability():
    _refreshAvailability() {
      if (!this.state.product || !this.state.hideSoldOut) return;

      const mountName = this._currentMountName();
      const apply = (radios, watt) => {
        radios.forEach(r => {
          const n = Number(r.value) || 0;
          const candidate = this._findVariant({ mountName, watt, count: n });
          r.disabled = !(candidate && candidate.available);
          r.closest('.card__quantity-button-wrapper')?.classList.toggle('is-disabled', r.disabled);
        });
      };
      apply(this.$w200Radios, '200W');
      apply(this.$w285Radios, '285W');
    }

    /* ---------------------------
      Variant resolution & form sync
    ----------------------------*/
    _currentMountName() {
      const checked = this.$mountRadios.find(r => r.checked);
      if (!checked) return '';
      const span = checked.closest('.oip__item')?.querySelector('label span');
      return span?.textContent?.trim() || '';
    }



    _findRayVariant({ mountType, watt, count, cableLength, adjustable }) {
      
      if (!this.state?.product) return null;

      // select which product's variants we are scanning
      const usingAdjust = adjustable === 'after';
      let sourceVariants = [];
      if (usingAdjust && this.state.adjustableVariants.length) {
        if (!this._parsedAdjVariants) {
          this._parsedAdjVariants = (this.state.adjustableVariants || []).map(v => ({
            raw: v,
            meta: this._parseVariant(v)
          }));
        }
        sourceVariants = this._parsedAdjVariants;
      } else {
        if (!this._parsedVariants) {
          this._parsedVariants = (this.state.variants || []).map(v => ({
            raw: v,
            meta: this._parseVariant(v)
          }));
        }
        sourceVariants = this._parsedVariants;
      }

      const wantCount = Number(count) || 0;
      const wantWatt  = String(watt || '').toUpperCase();
      const wantCable = String(cableLength || '').toLowerCase();
      const wantMount = (mountType || '').toLowerCase();
      // Filter on ALL axes
      let candidates = sourceVariants.filter(v =>
        Number(v.meta.count) === wantCount &&
        String(v.meta.watt).toUpperCase() === wantWatt &&
        String(v.meta.cableLength).toLowerCase() === wantCable &&
        String(v.meta.mountType).toLowerCase() === wantMount
      );

      // Prefer available
      const available = candidates.find(v => v.raw.available || v.meta.available);
      return available || candidates[0] || null;
    }

    _updateVariantSelection() {
      const { mountType, panelWatt, panelCount, cableLength, adjustable } = this.state;
      const match = this._findRayVariant({
        mountType,
        watt: panelWatt,
        count: panelCount,
        cableLength,
        adjustable
      });
      if (match) {
        this.state.selectedVariant = match.raw;
        this._toggleSoldOutMessage(false);

        // Sync <select name="id">
        const form = this.formId ? document.getElementById(this.formId) : null;
        const select = form?.querySelector('select[name="id"]');
        if (select) {
          select.value = match.raw.id;
          select.dispatchEvent(new Event('change', { bubbles:true }));
        }
      } else {
        this.state.selectedVariant = null;
        this._toggleSoldOutMessage(true);
      }
    }


    _toggleSoldOutMessage(show) {
      this.classList.toggle('variant-unavailable', !!show);

      // disable ATC
      const form = this.formId ? document.getElementById(this.formId) : null;
      form?.querySelectorAll('[data-bundle-atc], [data-bundle-buynow], .product-form__submit')
        .forEach(btn => btn.disabled = !!show);
    }

    /* ---------------------------
      Theme integration events
    ----------------------------*/
    _updateDisplayedPrice(base, compare, save) {
      const root = this.closest('[id^="shopify-section"]') || document;
      const wrap = root.querySelector('.product-meta__price-list-container');
      if (!wrap) return; // container not ready yet

      wrap.querySelector('[data-price]').textContent   = this._money(base);
      wrap.querySelector('[data-compare]').textContent = this._money(compare);

      const label = wrap.querySelector('.label--highlight');
      if (label) {
        label.textContent = `Save ${this._money(save)}`;
      }
    }


    _emitState() {
      const card = this._getCheckedMountCard?.();
      const { mountName } = this._readMountMeta?.(card) || { mountName: '' };

      // --- base/main variant prices
      const basePrice   = Number(this.state.selectedVariant?.price || 0);
      const baseCompare = Number(this.state.selectedVariant?.compare_at_price || basePrice);


      const bracketEach          = 0;
      const bracketCompareEach   = 0;

      // helper to compute line totals
      const line = (qty, each, eachCmp) => {
        const q = Number(qty) || 0;
        const e = this._num(each);
        const c = this._num(eachCmp) || e;
        const price   = q * e;
        const compare = q * c;
        const save    = Math.max(0, compare - price);
        return { qty: q, each: e, price, compare, save };
      };

      // ⬇️ add-ons aggregate + per-item detail
      const addonsRaw = (this.state.addons || []).filter(a => a.variantId && a.qty > 0);
      const addonsItems = addonsRaw.map(a => {
        const l = line(a.qty, a.each, a.compare);
        return { img_src: a.img_src, title: a.title, variantId: a.variantId, ...l };
      });
      const addonsTotals = addonsItems.reduce((acc, it) => {
        acc.price += it.price; acc.compare += it.compare; acc.save += it.save; return acc;
      }, { price:0, compare:0, save:0 });


      // grand totals
      const grandPrice   = basePrice + addonsTotals.price;
      const grandCompare = baseCompare + addonsTotals.compare;
      const grandSave    = Math.max(0, grandCompare - grandPrice);

      const detail = {
        mountIndex: this.state.mountIndex,
        mountType: this.state.mountType,
        prodIndex: this.state.prodIndex,
        mountName,
        adjustable: this.state.adjustable,
        cableLength: this.state.cableLength,
        panel: { watt: this.state.panelWatt, count: this.state.panelCount },
        storage: {
          count: this.state.storageCount,
          variantId: this.state.storageVariantId,
          baseWatt: this.baseBatteryWatt,
          totalWatt: this.baseBatteryWatt * (1 + (Number(this.state.storageCount) || 0))
        },
        bracketVariantId: this.state.bracketVariantId,
        derived: {
          bracketQuantity: Math.max(0, Number(this.state.panelCount) || 0),
          selectedRayQty: this.state.selectedRayQty
        },
        addons: addonsItems
      };

      const prices = {
        basePrice,
        baseCompare,
        bracketEach,
        bracketCompareEach,
        grandPrice : this._num(grandPrice),
        grandCompare : this._num(grandCompare),
        grandSave : this._num(grandSave)
      };

      this._updateDisplayedPrice(basePrice, baseCompare, grandSave);

      this.dispatchEvent(new CustomEvent('ray:change', { detail: {...detail, prices}, bubbles: true }));
    }

  };
  window.customElements.define("ray-variants", RayVariants);



  var RaySOD = class extends CustomHTMLElement {
    connectedCallback() {
      // Source <ray-variants>
      const forSel = this.getAttribute('for');
      this.$source = forSel ? document.querySelector(forSel) : this._nearestVariants();
      if (!this.$source) {
        console.warn('[ray-sod] Could not locate <ray-variants>. Provide `for="#id"`.'); 
        return;
      }
      // Use the element’s own children as the box
      this.$box = this.firstElementChild || this;

      // Cache row refs by order in your provided markup
      const rows = [...this.$box.querySelectorAll('.sod-line-item')];
      this.$rowBase    = rows[0] || null;       
      this.$rowBracket = rows[1] || null;
      this.$rowMicro  = rows[2] || null; 
      this.$rowCable  = rows[3] || null; 
      this.$dynamic    = this.querySelector('[data-sod-dynamic]');    
      this.$grand = this.querySelector('[data-sod-grand]');


      this._onChange = (e) => {
        if (e.target !== this.$source && e.currentTarget !== this.$source) return;
        // Prefer event payload; fall back to snapshot if needed
        const detail = e.detail || (typeof this.$source.getSnapshot === 'function' ? this.$source.getSnapshot() : null);
        this.render(detail);
      };
      this.$source.addEventListener('ray:change', this._onChange);

      // Initial paint
      if (typeof this.$source.getSnapshot === 'function') {
        try { this.render(this.$source.getSnapshot()); } catch(e) {}
      }
    }

    disconnectedCallback() {
      if (this.$source && this._onChange) {
        this.$source.removeEventListener('ray:change', this._onChange);
      }
    }

    /* ---------------- Rendering ---------------- */
    render(detail) {
      if (!detail) return;
      // Pull data from either the rich snapshot or minimal event
      const money = (c) => detail.prices?.money ? detail.prices.money(c) : this._money(c);

      this._show(this.$dynamic, false);
      // Panels
      const panelQty   = Number(detail.panel?.qty ?? detail.panel?.count ?? 0);
      const panelWattT = Number(detail.panel?.totalWatt ?? 0); // e.g., 800
      const panelTitle = panelWattT ? `${panelWattT}W Solar panel` : (detail.panel?.watt ? `${detail.panel.watt} Solar panel` : 'Solar panel');

      // Storage
      const storageQty = Number(detail.storage?.qty ?? detail.storage?.count ?? 0);
      const storagePrice = Number(detail.prices?.expansionEach * storageQty);

      // Bracket
      const rayQty = Number(detail.derived?.selectedRayQty)
      const hasBracket = !!(detail.bracket?.has ?? detail.bracketVariantId);
      const bracketQty = Number(detail.bracket?.qty ?? detail.derived?.bracketQuantity ?? panelQty);
      const bracketPrice = Number(detail.prices?.bracketEach * rayQty);
      const bracketCompare = Number(detail.prices?.bracketCompareEach * rayQty);

      // Prices
      const basePrice    = Number(detail.prices?.basePrice || 0);

      let baseLabel = `${panelQty}x`
      let baseTitle = '';
      if (panelQty > 0 ) {
        baseTitle += `${panelTitle}`;
      }
      // Write rows
      this._writeRow(this.$rowBase, baseLabel, baseTitle, "");
      this._show(this.$rowBase, true);

      this._writeRow(this.$rowBracket, `${bracketQty}x`, `Adjustable Bracket`, "");
      this._show(this.$rowBracket, true);

      this._writeRow(this.$rowMicro, `1x`, `Microinverter`, "");
      this._show(this.$rowMicro, true);

      this._writeRow(this.$rowCable, `1x`, `AC Cable`, "");
      this._show(this.$rowCable, true);

      this._renderMinSOD(detail);



      // Add-ons container (create if absent)
      let addonsBox = this.$box.querySelector('[data-sod-addons]');
      if (!addonsBox) {
        addonsBox = document.createElement('div');
        addonsBox.setAttribute('data-sod-addons','');
        addonsBox.className = 'sod-line-item-group';
        // insert after bracket row
        (this.$rowBracket?.parentNode || this.$box).insertBefore(addonsBox, this.$rowBracket?.nextSibling || null);
      } else {
        addonsBox.innerHTML = '';
      }

      const addonItems = detail.prices?.lines?.addons?.items || detail.addons || [];
      if (addonItems.length) {
        addonItems.forEach(it => {
          const row = document.createElement('div');
          row.className = 'sod-line-item';
          row.innerHTML = `
            <div class="h_16">${it.qty}x</div>
            <div class="h_16">${this._escape(it.title || 'Add-on')}</div>
            <div class="h_16 sod-price" style="font-weight:600;"></div>
          `;
          addonsBox.appendChild(row);
        });
      }

      const grandPrice = Number(detail.prices?.grandPrice || 0);
      const freeGiftEl = document.getElementById("pdp-free-gift");
      let shouldAppendGift = false;
      if (freeGiftEl) {
        const thresholdAttr = freeGiftEl.dataset.priceThreshold;
        const threshold = Number(thresholdAttr);

        if (!isNaN(threshold) && thresholdAttr !== undefined && thresholdAttr !== "") {
          if (grandPrice > threshold) {
            shouldAppendGift = true;
          } 
        } else {
          shouldAppendGift = true;
        }
      }

      // --- GIFT ROW APPEND (only when shouldAppendGift is true) ---
      if (shouldAppendGift) {
        const giftRow = document.createElement("div");
        giftRow.className = "sod-line-item";
        giftRow.innerHTML = `
            <div class="h_16">1x</div>
            <div class="h_16">Free Wifi Repeater</div>
            <div class="h_16 sod-price" style="font-weight:600;"></div>
        `;
        addonsBox.appendChild(giftRow);
      }


      // Totals
      const $grandPrice   = this.$grand?.querySelector('[data-sod-grand-price]');
      const $grandCompare = this.$grand?.querySelector('[data-sod-grand-compare]');
      const $grandSave    = this.$grand?.querySelector('[data-sod-grand-save]');

      if ($grandPrice)   $grandPrice.textContent = money(detail.prices?.grandPrice);
      if ($grandCompare) {
        if (Number(detail.prices?.grandCompare) > Number(detail.prices?.grandPrice)) {
          $grandCompare.textContent = money(detail.prices?.grandCompare);
          $grandCompare.style.display = '';
        } else {
          $grandCompare.textContent = '';
          $grandCompare.style.display = 'none';
        }
      }
      if ($grandSave) {
        if (detail.prices?.grandSave > 0) {
          $grandSave.textContent = `Save ${money(detail.prices?.grandSave)}`;
          $grandSave.style.display = '';
        } else {
          $grandSave.textContent = '';
          $grandSave.style.display = 'none';
        }
      }
    }

    _renderMinSOD(detail) {
      const root    = this;
      const minWrap = root.querySelector('[data-sod-min]');
      if (!minWrap) return;

      const minDescEl = minWrap.querySelector('[data-sod-min-desc]');
      if (!minDescEl) return;

      if (!detail) { minDescEl.textContent = ''; return; }

      const parts = [];

      // --- Base items (mirror your render logic) ---
      const panelQty   = Number(detail.panel?.qty ?? detail.panel?.count ?? 0);
      const panelWattT = Number(detail.panel?.totalWatt ?? 0);
      const panelTitle =
        panelWattT ? `${panelWattT}W Solar panel`
          : (detail.panel?.watt ? `${detail.panel.watt} Solar panel` : 'Solar panel');

      if (panelQty > 0) parts.push(`${panelQty}x ${panelTitle}`);

      const bracketQty = Number(detail.bracket?.qty ?? detail.derived?.bracketQuantity ?? panelQty);
      // only include bracket if it makes sense in your product (you always show it in render)
      if (bracketQty > 0) parts.push(`${bracketQty}x Adjustable Bracket`);

      // you always show these as 1x in render
      parts.push(`1x Microinverter`);
      parts.push(`1x AC Cable`);

      // --- Add-ons from detail (same source as render) ---
      const addonItems = detail.prices?.lines?.addons?.items || detail.addons || [];
      addonItems.forEach(it => {
        const q = Number(it?.qty ?? 0);
        const t = (it?.title || 'Add-on').toString().trim();
        if (q > 0 && t) parts.push(`${q}x ${t}`);
      });

      // --- Gift (mirror your render gift logic, but without needing addonsBox) ---
      const grandPrice = Number(detail.prices?.grandPrice || 0);
      const freeGiftEl = document.getElementById("pdp-free-gift");

      let shouldAppendGift = false;
      if (freeGiftEl) {
        const thresholdAttr = freeGiftEl.dataset.priceThreshold;
        const threshold = Number(thresholdAttr);

        if (!isNaN(threshold) && thresholdAttr !== undefined && thresholdAttr !== "") {
          if (grandPrice > threshold) shouldAppendGift = true;
        } else {
          shouldAppendGift = true; // no threshold set => always show gift
        }
      }

      if (shouldAppendGift) {
        parts.push(`1x Free Wifi Repeater`);
      }

      minDescEl.textContent = parts.length ? parts.join(' + ') : '';
    }

    _writeRow(row, qtyText, titleText, priceText) {
      if (!row) return;
      const cells = row.querySelectorAll('.h_16');
      if (cells[0]) cells[0].textContent = qtyText;
      if (cells[1]) cells[1].textContent = titleText;
      if (cells[2]) cells[2].textContent = priceText;
    }

    _makeRow() {
      const div = document.createElement('div');
      div.className = 'sod-line-item';
      div.innerHTML = `
        <div class="h_16 sod-qty"   data-sod-qty>1x</div>
        <div class="h_16 sod-title" data-sod-title></div>
        <div class="h_16 sod-price" data-sod-price style="font-weight:600;"></div>
      `;
      return div;
    }
    _setRow(row, { qty, title, price }) {
      if (!row) return;
      if (qty   != null) (row.querySelector('[data-sod-qty]')   || row.children[0]).textContent = qty;
      if (title != null) (row.querySelector('[data-sod-title]') || row.children[1]).textContent = title;
      if (price != null) (row.querySelector('[data-sod-price]') || row.children[2]).textContent = '';
    }

    _show(el, on=true) { if (el) el.style.display = on ? '' : 'none'; }

    _getSectionRoot() {
      if (!this._sectionRoot) {
        this._sectionRoot = this.closest?.('[id^="shopify-section-"]') || document;
      }
      return this._sectionRoot;
    }
     /* ---------- Bundle SOD read from DOM ---------- */
    _readBundleSodFromDom() {
      // Find the selected card in the provided panel (supports .bundle-card or .box)
      const root = this._getSectionRoot(this) || document;
      const panel = root.querySelector(this.bundlePanelSel);
      if (!panel) return [];

      const card = panel.querySelector('.bundle-radio:checked')?.closest('.bundle-card, .box')
                || panel.querySelector('.bundle-card.is-selected, .box.is-selected')
                || panel.querySelector('.bundle-card, .box');

      if (!card) return [];

      try {
        const raw = card.getAttribute('data-sod') || '[]';
        const arr = JSON.parse(raw);
        return Array.isArray(arr) ? arr : [];
      } catch (_e) {
        return [];
      }
    }
    
    _readBundleTitleFromDom() {
      const root  = this._getSectionRoot(this) || document;
      const panel = root.querySelector('#tab1 .bundle-wrapper');
      if (!panel) return '';
      const card = panel.querySelector('.bundle-radio:checked')?.closest('.bundle-card, .box')
              || panel.querySelector('.bundle-card.is-selected, .box.is-selected')
              || panel.querySelector('.bundle-card, .box');
      if (!card) return '';
      return card.getAttribute('data-title') || card.querySelector('.h_16')?.textContent?.trim() || '';
    }

    _nearestVariants() {
      // Fallback: nearest preceding <glory-variants> sibling or in the same section
      let el = this.previousElementSibling;
      while (el) {
        if (el.tagName && el.tagName.toLowerCase() === 'glory-variants') return el;
        el = el.previousElementSibling;
      }
      return document.querySelector('glory-variants');
    }

    _escape(s) { return String(s).replace(/[&<>"']/g, m => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m])); }


    _money(cents) {
      const n = Number(cents) || 0;

      try {
        const fmt = window.themeVariables?.settings?.currencyCodeEnabled
          ? window.themeVariables?.settings?.moneyWithCurrencyFormat
          : window.themeVariables?.settings?.moneyFormat;

        if (typeof window.formatMoney === 'function' && fmt) {
          return window.formatMoney(n, fmt);
        }
      } catch (_e) {}

      const v = n / 100;

      return new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR'
      }).format(v);
    }


  }
  window.customElements.define("ray-sod", RaySOD);

  var InteractiveRayImage = class extends CustomHTMLElement {
    connectedCallback() {
      this.forSel   = this.getAttribute('for') || null;
      this.$section = this.closest('[id^="shopify-section-"]') || document;

      // qty badges
      this.$qtyBatt    = this.querySelector('[data-qty-batt]');
      this.$qtyPanel   = this.querySelector('[data-qty-panel]');
      this.$qtyBracket = this.querySelector('[data-qty-bracket]');
      this.$qtyCable = this.querySelector('[data-qty-cable]');

      // Maps
      this.solarMap   = this._buildKeyedMap('.solar-panel-wrapper .solar-panel', 'data-panel-');
      this.bracketMap = this._buildKeyedMap('.ray-com.bracket img', 'data-bracket-');
      this.cableMap   = this._buildKeyedMap('.ray-com.cable img',  'data-cable-');
      this.accessMap  = this._buildKeyedMap('.accessories-wrapper [data-access-1], .accessories-wrapper [data-access-2], .accessories-wrapper [data-access-3]', 'data-access-');

      

      // Bind to <ray-variants>
      this._onChange = (e) => this._applyState(e.detail || {});
      this._wireGV();

      // Hide everything initially
      this._hideAllMap(this.solarMap);
      this._hideAllMap(this.bracketMap);
      this._hideAllMap(this.cableMap);
      this._hideAllMap(this.accessMap);

      // Optimize Interactive images to load after all scripts loaded in.
      this._stateApplied = false;
      this._readyResolved = false;
      const imagesReady = this._waitForImagesStable(this);
      const stateReady = new Promise(res => {
        if (this._stateApplied) return res();

        this._resolveOnState = () => {
          if (this._readyResolved) return;
          res();
        };
      });

      Promise.all([imagesReady, stateReady]).then(() => {
        console.log("test-interactive: checking if image ready")
        if (this._readyResolved) return;
        this._readyResolved = true;
        this._markReady();
      });
    }

    disconnectedCallback() {
      if (this.$gv && this._onChange) this.$gv.removeEventListener('ray:change', this._onChange);
      this._gvMO?.disconnect();
    }

    /* ---------------- Binding ---------------- */

    _wireGV() {
      const tryAttach = () => {
        const target = this.forSel
          ? this.$section.querySelector(this.forSel)
          : this.$section.querySelector('ray-variants');
        if (!target) return false;
        this.$gv = target;
        this.$gv.addEventListener('ray:change', this._onChange);
        this.$gv.dispatchEvent(new CustomEvent('ray:snapshot', { bubbles: true }));
        return true;
      };

      if (!tryAttach()) {
        this._gvMO = new MutationObserver(() => { tryAttach(); });
        this._gvMO.observe(this.$section, { childList: true, subtree: true });
      }
    }

    /* ---------------- State Application ---------------- */

    _applyState(detail) {
      this._stateApplied = true;
      if (this._resolveOnState) {
        this._resolveOnState();
        this._resolveOnState = null;
      }

      const panelWattRaw = detail?.panel?.watt || '';
      const panelWatt    = this._normalizeWatt(panelWattRaw);
      const panelCount   = parseInt(detail?.panel?.count ?? 0, 10) || 0;
      const prodIndex    = parseInt(detail?.prodIndex ?? 0, 10) || 0;
      const cableLength  = (detail?.cableLength || '').toLowerCase(); // "5m","10m"
      const isAdjustable = detail.adjustable === 'after'? true: false ;

      const hasSolar = panelCount > 0;

      /* --- Solar overlays (1) --- */
      this._hideAllMap(this.solarMap);

      const solarKey = panelWatt && panelCount ? `${panelWatt}-${panelCount}` : '';
      const solarImg = this.solarMap.get(solarKey);
      if (solarImg) this._show(solarImg, true);

      /* --- Bracket (only 1) --- */
      this._hideAllMap(this.bracketMap);

      if (hasSolar && (prodIndex === 1 || prodIndex === 2 || prodIndex === 3)) {
        let br = this.bracketMap.get(String(prodIndex));
        if( prodIndex == 2 && isAdjustable){
          br = this.bracketMap.get(String(4));
        }
        
        if (br) this._show(br, true);
      }

      /* --- Cable (only 1) --- */
      this._hideAllMap(this.cableMap);
      let cableIdx = cableLength === '10m' ? '2' : '1'; // default 5m
      const cableEl = this.cableMap.get(cableIdx);
      if (cableEl) {
        this._setText(this.$qtyCable, `${cableLength}`)
        this._show(cableEl, true)
      };

      /* --- Micro inverter always visible (do nothing) --- */

      /* --- Qty text badges --- */
      if (this.$qtyPanel) {
        if (hasSolar) {
          this._setText(this.$qtyPanel, `${panelWatt.toUpperCase()} x ${panelCount}`);
          this._show(this.$qtyPanel, true);
        } else {
          this._show(this.$qtyPanel, false);
        }
      }

      if (this.$qtyBracket) {
        if (hasSolar && prodIndex) {
          this._setText(this.$qtyBracket, `${panelCount} x Bracket`);
          this._show(this.$qtyBracket, true);
        } else {
          this._show(this.$qtyBracket, false);
        }
      }

      // ------------------ ACCESSORIES ------------------
      const accessoriesWrapper = this.querySelector('.accessories-wrapper');
      if (accessoriesWrapper) {
        accessoriesWrapper.innerHTML = '';
      }

      const addons = (detail?.prices?.lines?.addons?.items || detail?.addons || []).filter(Boolean);

      // Create and append accessory images dynamically based on selected add-ons
      addons.forEach((addon, index) => {
        // Find the image source from the addon data
        let imgSrc = '';
        
        // Check if we have the product card HTML structure with image
        if (addon.img_src) {
          // Use the img_src property if available
          imgSrc = `${addon.img_src}`;
        } else if (addon.image) {
          // Fallback to image property
          imgSrc = addon.image;
        } else if (addon.handle) {
          // Generate image URL from product handle (common pattern)
          imgSrc = `/cdn/shop/files/${addon.handle}.png`;
        }
        
        // If we found an image source, create and append the image element
        if (imgSrc && accessoriesWrapper) {
          const img = document.createElement('img');
          img.className = 'access-img';
          img.setAttribute('data-access', index + 1);
          img.src = imgSrc;
          img.loading = 'lazy';
          img.alt = addon.title || addon.name || 'Accessory';
          
          accessoriesWrapper.appendChild(img);
        }
      });

      // If no accessories found, you might want to show a placeholder or hide the wrapper
      if (accessoriesWrapper && accessoriesWrapper.children.length === 0) {
        accessoriesWrapper.style.display = 'none';
      } else if (accessoriesWrapper) {
        accessoriesWrapper.style.display = '';
      }
    
    }

    /* ---------------- Helpers ---------------- */

    _normalizeWatt(w) {
      const m = String(w).match(/(\d+)/);
      if (!m) return '';
      return `${m[1]}w`;
    }

    _buildKeyedMap(selector, pfx) {
      const map = new Map();
      const nodes = this.querySelectorAll(selector);
      const prefix = pfx.toLowerCase();

      nodes.forEach(el => {
        for (const attr of el.getAttributeNames()) {
          const key = attr.toLowerCase();
          if (key.startsWith(prefix)) {
            map.set(key.replace(prefix, ''), el);
            break;
          }
        }
      });
      return map;
    }

    _show(el, on=true) { if (el) el.style.display = on ? '' : 'none'; }
    _hideAllMap(map) { map.forEach(el => this._show(el, false)); }

    _showOnly(pairs) {
      pairs.forEach(([el, on]) => this._show(el, !!on));
    }

    _setText(el, text) {
      if (el && el.textContent !== String(text)) el.textContent = String(text);
    }
     _waitForImagesStable(root, {
      selector = 'img',     
      settleMs = 500,       
      timeoutMs = 4000      
    } = {}) {
      const isDone = (img) => img.complete && img.naturalWidth >= 0;

      const trackImg = (img) => {
        if (!img || img.tagName !== 'IMG') return Promise.resolve();
        if (isDone(img)) return Promise.resolve();

        // If browser supports decode(), it’s more reliable than just load event
        if (img.decode) {
          return img.decode().catch(() => {});
        }

        return new Promise((res) => {
          img.addEventListener('load',  res, { once: true });
          img.addEventListener('error', res, { once: true });
        });
      };

      return new Promise((resolve) => {
        let settledTimer = null;
        let timeoutTimer = null;

        const collect = () => [...root.querySelectorAll(selector)];

        const finishWhenStable = async () => {
          clearTimeout(settledTimer);
          settledTimer = setTimeout(async () => {
            const imgs = collect();

            // IMPORTANT: don’t wait for lazy images that likely won’t load yet
            const activeImgs = imgs.filter(img => (img.getAttribute('loading') || '').toLowerCase() !== 'lazy');

            await Promise.all(activeImgs.map(trackImg));
            cleanup();
            resolve();
          }, settleMs);
        };

        const mo = new MutationObserver(() => finishWhenStable());
        mo.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'srcset'] });

        const cleanup = () => {
          mo.disconnect();
          clearTimeout(settledTimer);
          clearTimeout(timeoutTimer);
        };

        timeoutTimer = setTimeout(() => { cleanup(); resolve(); }, timeoutMs);

        // initial run
        finishWhenStable();
      });
    }

    _markReady() {
      this.classList.add('is-ready');
      const content = this.querySelector('[data-content]');
      if (content) content.hidden = false;
    }
  };
  window.customElements.define("interactive-ray-image", InteractiveRayImage);


})();


